import { ImgHTMLAttributes, useEffect, useState, VideoHTMLAttributes } from "react";
import { useAmn } from "../contexts/AmnContext"
import { Disposition } from "../models/dispositionEnum";
import { changeGender, changeVoice, toggleSubtitles } from "../utils/configurationUtils";
import { allowSpeech, preventSpeech, sendActivity } from "../utils/globalUtils";
import { Legend } from "./Legend";
import ReactDOM from 'react-dom';
import { RetorikConfiguration } from "../configs/retorikConfig";
import { SessionState } from "../models/sessionState";

const DispositionHandler = () =>{
    let amn = useAmn();
    const [showTestMenu, setShowTestMenu] = useState<boolean>(false);
    //const [showAvatar, setShowAvatar] = useState<boolean>(false);
    //const [showLegend, setShowLegend] = useState<boolean>(false);

    useEffect(()=>{
        if(amn.testMode){
            setShowTestMenu(true);
        }
    }, [amn.testMode])

    useEffect(()=>{
        if(!amn.testMode && amn.sessionState == SessionState.Started){
            startForm("Introduction");
        }
    }, [amn.sessionState])
    
    useEffect(()=>{
        console.log("CHANGE DISPOSITION")
        switch (amn.disposition) {
            case Disposition.Enseignant:
                    ChangeDisposition(Disposition.Enseignant);
                break;
            case Disposition.Patiente:
                    ChangeDisposition(Disposition.Patiente);
                break;
            case Disposition.DialogueEchange:
                    ChangeDisposition(Disposition.DialogueEchange);
                break;
            case Disposition.DialogueEchangeApprenant:
                    ChangeDisposition(Disposition.DialogueEchangeApprenant);
                break;
            case Disposition.DialogueQuestionEchange:
                ChangeDisposition(Disposition.DialogueQuestionEchange);
                break;
            case Disposition.DebriefEchange:
                ChangeDisposition(Disposition.DebriefEchange);
                break;
            case Disposition.SelectionEnvironnement:
                ChangeDisposition(Disposition.SelectionEnvironnement);
                break;
            case Disposition.DebriefEnvironnement:
                ChangeDisposition(Disposition.DebriefEnvironnement);
                break;
            default:
                break;
        }
    }, [amn.disposition])


    const ChangeDisposition = (disp : Disposition) =>{
        console.log(`Change disposition : ${disp}`);
        //Get all element to modify 
        let container = document.getElementById("retorik-container");
        let botResponseElement = document.getElementById("retorik-botResponse");
        let config : RetorikConfiguration = amn.retorikConfig;
    
        //reset
        config = toggleSubtitles(config, true);


        //Create small avatar if not existing (for restitution)
        let botAvatarElement = document.getElementById("avatar") as HTMLImageElement;
        if(!botAvatarElement){
            botAvatarElement = document.createElement('img');
            botAvatarElement.src =  'images/avatar2.png';
            botAvatarElement.alt = "Enseignant"
            botAvatarElement.id = "avatar"
            botAvatarElement.className = `relative col-start-8 row-start-6 row-end-7 justify-self-start`
            container?.appendChild(botAvatarElement);
        }
    
        if(disp == Disposition.Enseignant){
            resetContainerClasses();
            config = changeGender("male", config);
            config = changeVoice("male", "HenriNeural", config);
            UpdateClassOnVideoEnd("patiente", false, Disposition.Enseignant);
            allowSpeech();
        }

        else if(disp == Disposition.Patiente){
            resetContainerClasses();
            config = changeGender("female", config);
            config = changeVoice("female", "DeniseNeural", config);
            UpdateClassOnVideoEnd("patiente", true, Disposition.Patiente);
            allowSpeech();
        }

            

        //Medecin qui parle
        else if(disp == Disposition.DialogueQuestionEchange){
            container?.classList.add("echangeQuestionDisp");
            container?.classList.remove("echangeDisp");
            container?.classList.remove("debriefEchangeDisp");
            container?.classList.remove("echangeDispApprenant");
            
            config = changeVoice("male", "HenriNeural", config);

            preventSpeech();
        }
        //Debrief avec legende
        else if(disp == Disposition.DebriefEchange){
            container?.classList.add("debriefEchangeDisp");
            container?.classList.remove("echangeQuestionDisp");
            container?.classList.remove("echangeDisp");
            container?.classList.remove("echangeDispApprenant");

            if(!document.getElementById("legendContainer")){
                let legendDivContainer = document.createElement('div');
                legendDivContainer.id = "legendContainer";
                legendDivContainer.className="rounded bg-black bg-opacity-card text-white py-4"
                ReactDOM.render(<Legend/>, legendDivContainer);
                container?.appendChild(legendDivContainer);
            }
            config = changeVoice("male", "HenriNeural", config);
            preventSpeech();

        }
        //Patiente qui parle
        else if (disp == Disposition.DialogueEchange){
            container?.classList.add("echangeDisp");
            container?.classList.remove("echangeQuestionDisp");
            container?.classList.remove("echangeDispApprenant");
            container?.classList.remove("debriefEchangeDisp");
            config = changeVoice("female", "DeniseNeural", config);

            allowSpeech();
        }
        //Apprenant qui parle    
        else if (disp == Disposition.DialogueEchangeApprenant){
            container?.classList.add("echangeDispApprenant");
            container?.classList.remove("echangeDisp");
            container?.classList.remove("echangeQuestionDisp");
            container?.classList.remove("debriefEchangeDisp");
            //config = changeVoice("female", config);
            console.log("changeVoice - ", amn.userInfo?.gender, amn.userInfo?.voice)
            config = changeVoice(amn.userInfo?.gender, amn.userInfo?.voice, config);
            preventSpeech();
        }

        else{
            container?.classList.remove("echangeDisp");
            container?.classList.remove("echangeDispApprenant");
            container?.classList.remove("echangeQuestionDisp");
            config = toggleSubtitles(config, false);
        }
        console.log("Set Config",config)
        amn.setRetorikConfig(config);
    }
    
    const UpdateClassOnVideoEnd = (className : string, add : boolean, disp : Disposition) =>{
        let loaded = 0;
        let ended = 0;
        let show = true;
        document.querySelectorAll("#retorik-animation video").forEach(
            (video ) => {
                let videoElement = video as HTMLMediaElement;
                (videoElement as HTMLMediaElement).onloadeddata = (ev : Event)=> {
                    console.log("onloadeddata", ev?.target)
                    var div = document.querySelector("#retorik-animation");
                    if(div){
                        (div as HTMLElement).style.display = "none";
                    }
                    loaded++;
                    if(loaded == 4){
                        console.log("all video loaded")
                        show = false;
                        if(div){
                            if(add){
                                div.classList.add(className);
                            }
                            else{
                                div.classList.remove(className);
                            }
                            (div as HTMLElement).style.display = "";
                        } 
                        loaded = 0;
                        document.querySelectorAll("#retorik-animation video").forEach(
                            (video) => {
                                let videoElement = video as HTMLMediaElement;
                                videoElement.onloadeddata = null;
                            }
                        );
                    }
                }
                /*var currentDisplayedVideo = document.querySelector("#retorik-animation video.opacity-100");
                if(currentDisplayedVideo){
                    (currentDisplayedVideo as HTMLMediaElement).onended = (ev : Event)=> {
                        if(!show){
                            console.log("Displayed video ended")
                            var div = document.querySelector("#retorik-animation");
                            if(div){
                                show = true;
                                (div as HTMLElement).style.display = "";
                            }
                            document.querySelectorAll("#retorik-animation video").forEach(
                                (video) => {
                                    let videoElement = video as HTMLMediaElement;
                                    videoElement.onended = null;
                                }
                            );
                        }
                    }
                }
                else{
                    var div = document.querySelector("#retorik-animation");
                    if(div){
                        show = true;
                        (div as HTMLElement).style.display = "";
                    }
                }*/
                
                /*var interval = addClassNameListener(videoElement, (srcList, oldSrcList)=>{
                    console.log("addClassNameListener", srcList, oldSrcList);
                    let apply : boolean = false;
                    switch (disp) {
                        case Disposition.Enseignant:
                            apply = srcList.indexOf("enseignant") > -1;
                            break;
                        case Disposition.Patiente:
                            apply = srcList.indexOf("patient") > -1;
                            break;
                        default:
                            break;
                    }
                    if(apply){
                        var currentDisplayedVideo = document.querySelector("#retorik-animation video.opacity-100");
                        (currentDisplayedVideo as HTMLMediaElement).onloadeddata = (ev : Event)=> {
                            console.log("onloadeddata", ev?.target)
                            var div = document.querySelector("#retorik-animation");
                            if(div){
                                if(add){
                                    div.classList.add(className);
                                }
                                else{
                                    div.classList.remove(className);
                                }
                            } 
                            //remove when proccessed
                            document.querySelectorAll("#retorik-animation video").forEach(
                                (video) => {
                                    let videoElement = video as HTMLMediaElement;
                                    videoElement.onloadeddata = null;
                                }
                            );
                        }
                        clearInterval(interval);                        
                    }
                })*/

                
                /*if(videoElement.onended == null){
                    console.log("ADD onended");
    
                    videoElement.onended = (ev : Event)=> {
                        let apply : boolean = false;
                        if(ev){
                            let videoSrcList = (ev?.target as HTMLElement)?.getElementsByTagName("source");
                            console.log((ev?.target as HTMLElement))
                            if(videoSrcList && videoSrcList.length > 0){
                                let videoSrc = videoSrcList[0].src;
                                
                                switch (disp) {
                                    case Disposition.Enseignant:
                                        apply = videoSrc.indexOf("enseignant") > -1;
                                        break;
                                    case Disposition.Patiente:
                                        apply = videoSrc.indexOf("patient") > -1;
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                        if(apply){
                            var div = document.querySelector("#retorik-animation");
                            if(div){
                                if(add){
                                    div.classList.add(className);
                                }
                                else{
                                    div.classList.remove(className);
                                }
                            } 
                            //remove when proccessed
                            document.querySelectorAll("#retorik-animation video").forEach(
                                (video) => {
                                    let videoElement = video as HTMLMediaElement;
                                    videoElement.onended = null;
                                }
                            );
                        }
                    }
                }*/
            }
        )
        /*document.querySelectorAll("#retorik-animation video").forEach(
            (video ) => {
                let videoElement = video as HTMLMediaElement;
                videoElement.style.display = "none";
                videoElement.onended = (ev : Event)=> {
                    let apply : boolean = false;
                    if(ev){
                        let videoSrcList = (ev?.target as HTMLElement)?.getElementsByTagName("source");
                        console.log(videoSrcList);
                        if(videoSrcList && videoSrcList.length > 0){
                            let videoSrc = videoSrcList[0].src;
                            //console.log(videoSrc);
                            switch (disp) {
                                case Disposition.Enseignant:
                                    apply = videoSrc.indexOf("enseignant") > -1;
                                    break;
                                case Disposition.Patiente:
                                    apply = videoSrc.indexOf("patient") > -1;
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
    
                    if(apply){
                        var div = document.querySelector("#retorik-animation");
                        if(div){
                            if(add){
                                div.classList.add(className);
                            }
                            else{
                                div.classList.remove(className);
                            }
                        } 
                        //remove when proccessed
                        document.querySelectorAll("#retorik-animation video").forEach(
                            (video) => {
                                let videoElement = video as HTMLMediaElement;
                                videoElement.style.display="";
                                videoElement.onended = null;
                            }
                        );
                    }
                }
            }
        );*/
    }

    const resetContainerClasses = () => {
        let container = document.getElementById("retorik-container");
        container?.classList.remove("echangeQuestionDisp");
        container?.classList.remove("echangeDisp");
        container?.classList.remove("echangeDispApprenant");
        container?.classList.remove("debriefEchangeDisp");
    }

    

    const startForm = (formId : string) => {
        if(formId.length > 0){
            sendActivity({
                type:"event",
                name: 'StartFormEvent',
                value: {
                      "type": 0,
                      "formId": formId,
                      "sectionId": "0"
                }
            });
            //setShowTestMenu(false);
        }
    }

    const sendTimers = () => {
        sendActivity({
            type:"event",
            name: 'FormActionEvent',
            value: {
                  "Type": 0,
                  "Property": "Conversation.AMNACA.Timers",
                  "Value":  JSON.stringify(amn.timer.timers),
                  "ForceUpdateProperties": "true"
            }
        });
    }

    const sendAnimation = () => {
        let animation = prompt("Entrer le nom de l'animation");
        const animationEvent = new CustomEvent('sendPlayAnimationEvent', {
            detail: {
              queue: animation?.replaceAll(" ","")?.split(",")
            }
          });
        
          document.dispatchEvent(animationEvent);
    }

    const changeDispositionButtonHandle = () =>{
        let animation = prompt("Entrer la disposition voulue");
        switch (animation) {
            case "enseignant":
              amn.setDisposition(Disposition.Enseignant);
              break;
            case "patiente":
              amn.setDisposition(Disposition.Patiente);
              break;
            case "dialogueEchange":
              amn.setDisposition(Disposition.DialogueEchange);
              break;
            case "dialogueQuestionEchange":
              amn.setDisposition(Disposition.DialogueQuestionEchange);
              break;
            case "dialogueEchangeApprenant":
                amn.setDisposition(Disposition.DialogueEchangeApprenant);
              break;
            case "selectionEnvironnement":
              amn.setDisposition(Disposition.SelectionEnvironnement);
              break;
            case "debriefEchange":
              amn.setDisposition(Disposition.DebriefEchange);
              break;
            case "debriefEnvironnement":
              amn.setDisposition(Disposition.DebriefEnvironnement);
              break;
            default:
              break;
          }
    }

    return (
        <>
        {
            showTestMenu &&
                <ul className="testButtons">
                    <li><button onClick={() => startForm("Introduction")}>Démarrer</button></li>
                    {/* <li><button onClick={() => startForm("Formulaire test")}>Formulaire dialogue</button></li> */}
                    <li><button onClick={() => startForm(window.prompt("Nom du formulaire :") ?? "")}>Formulaire spécifique</button></li>
                    <li><button onClick={() => startForm("Test selection environnement")}>Sélection environnement</button></li>
                    <li><button onClick={() => sendTimers()}>Envoyer les timers</button></li>
                    <li><button onClick={() => sendAnimation()}>Lancement d'animations</button></li>
                    <li><button onClick={() => changeDispositionButtonHandle()}>Changement de disposition</button></li>
                    <li><button onClick={() => document.location.href="/"}>Retour à l'accueil</button></li>
                </ul>
        }
        </>
        )
}


const smoothPatienteTransition = (stand : boolean ) => {
    let container = document.getElementById("retorik-container")
    let animation = document.getElementById("retorik-animation")
    
    if(container && animation){
        container.style.transition='background-position-y 3s cubic-bezier(0.24, 0.76, 0.27, 0.89) 0s';
        animation.style.transition='bottom 3s cubic-bezier(0.24, 0.76, 0.27, 0.89) 0s, height 3s cubic-bezier(0.24, 0.76, 0.27, 0.89) 0s';
        if(stand){
            animation.style.bottom = "-20vh";
            animation.style.height = "125vh"
            container.style.setProperty("background-position-y", "calc(65% + 20vh)", "important")
        }
        else{
            animation.style.bottom = "0"
            animation.style.height = "100vh"
            container.style.setProperty("background-position-y", "65%", "important")
        }
    }
}

const handleVideoEnd = () =>{
    document.querySelectorAll("#retorik-animation video").forEach(
        (video ) => {
            let videoElement = video as HTMLMediaElement;
            if(videoElement.onplaying == null){
                console.log("ADD ONPLAYING");

                videoElement.onplaying = (ev : Event)=> {
                    if(ev){
                        let videoSrcList = (ev?.target as HTMLElement)?.getElementsByTagName("source");
                        
                        if(videoSrcList && videoSrcList.length > 0){
                            let videoSrc = videoSrcList[0].src;
                            
                            //Exemple
                            if(videoSrc.indexOf("getup") > -1){
                                smoothPatienteTransition(true);
                            }
    
                            //IDLE
                            else if(videoSrc.indexOf("sitdown") > -1){
                                smoothPatienteTransition(false);
                            }
                        }
                    }
                }
            }
        }
    )
}
    
    export {
        DispositionHandler,
        handleVideoEnd
    }